import {V1ETLS3ConfigurationIDOCToArray} from "../../../../util/Payload";
import EnterpriseComponent from "../../EnterpriseComponent";
import {v4 as uuidv4} from "uuid";
import EnlilAxios from "../../../../util/EnlilAxios";

class ETLS3ConfigurationEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let QBE = {
            "ShifamedMessage": {
                "-idoc": "v1.ETLS3Configuration-001",
                "-id": uuidv4(),
                "ETLS3Configuration": {
                    '_attributes': {
                        'limit': pageSize,
                        'sort': this.getFormattedSortSpecification(),
                        'offset': (page - 1) * pageSize
                    },
                    "QueryGroups": {
                        "QueryGroup": [
                            {
                                "Name": "primary",
                                "Operator": "AND",
                                "Type": "QueryGroup",
                                "Membership": {
                                    "Member": []
                                }
                            }
                        ]
                    }
                }
            }
        }
        let queryPayload = this.prepareQueryPayload();

        if (queryPayload.size > 0) {
            for (const [key, value] of queryPayload) {
                if (key.includes("_query")) continue;

                let operator = "EQUAL";
                if (queryPayload.get(key + "_query") !== undefined) {
                    operator = queryPayload.get(key + "_query")
                }
                QBE.ShifamedMessage.ETLS3Configuration.QueryGroups.QueryGroup[0].Membership.Member.push({
                    "Type": "Attribute",
                    "Name": key,
                    "Value": value,
                    "Operator": operator
                })
            }
        }

        EnlilAxios({
            method: "GET",
            url: "t1/v1/etl_s3_configurations",
            json: true,
            params: {
                "QBE": btoa(JSON.stringify(QBE))
            },
            headers: {
                "idoc-response": this.getIDOCResponse() ?? "v1.ETLS3Configuration-001",
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1ETLS3ConfigurationIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

    enterpriseComponentPostIDOC = () => {
        let payload = {};

        let configuration = {};

        configuration["USID"] = this.getAttributeValue("USID");
        configuration["Name"] = this.getAttributeValue("Name");
        configuration["AWSAccessKeyID"] = this.getAttributeValue("AWSAccessKeyID");
        configuration["AWSSecretAccessKey"] = this.getAttributeValue("AWSSecretAccessKey");
        configuration["AWSRegion"] = this.getAttributeValue("AWSRegion");
        configuration["Bucket"] = this.getAttributeValue("Bucket");
        configuration["Path"] = this.getAttributeValue("Path");

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.ETLS3Configuration-001";
        payload.ShifamedMessage.ETLS3Configuration = configuration;

        return payload;
    };

    performInsert() {
        let payload = this.enterpriseComponentPostIDOC();

        let options = {
            method: "POST",
            url: "t1/v1/etl_s3_configurations",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.ETLS3Configuration-001",
                "idoc-response": "v1.ETLS3Configuration-001"
            },
        };
        this.notifyInsertStartListeners();
        EnlilAxios(options)
            .then(response => {
                this.insertEnterpriseComponentSuccess(V1ETLS3ConfigurationIDOCToArray(response.data));
            })
            .catch(error => {
                this.insertEnterpriseComponentFailed(error);
            });
    };

    enterpriseComponentPutIDOC = () => {
        let payload = {};

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.ETLS3Configuration-001";
        payload.ShifamedMessage.ETLS3Configuration = this.preparePUTPayload();

        return payload;
    };

    performUpdate = () => {
        let payload = this.enterpriseComponentPutIDOC();

        let options = {
            method: "PUT",
            url: "t1/v1/etl_s3_configurations",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.ETLS3Configuration-001",
                "idoc-response": "v1.ETLS3Configuration-001",
            },
        };
        this.notifyUpdateStartListeners();
        EnlilAxios(options)
            .then(response => {
                this.updateEnterpriseComponentSuccess(V1ETLS3ConfigurationIDOCToArray(response.data));
            })
            .catch(error => {
                this.updateEnterpriseComponentFailed(error);
            });
    };

    performDelete() {
        let payload = {
            "ShifamedMessage": {
                "-idoc": "v1.ETLS3Configuration-001",
                "ETLS3Configuration": {
                    "USID": this.getEnterpriseObject().getEnterpriseComponent("ETLS3Configuration").getAttributeValue("USID"),
                }
            }
        }

        let options = {
            method: "DELETE",
            url: "t1/v1/etl_s3_configurations",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.ETLS3Configuration-001"
            },
        };
        this.notifyDeleteStartListeners();
        EnlilAxios(options)
            .then(() => {
                this.deleteEnterpriseComponentSuccess();
            })
            .catch(error => {
                this.deleteEnterpriseComponentFailed(error);
            });
    };

}

export default ETLS3ConfigurationEnterpriseComponent;